// NC State's undergraduate majors (#2840). Read on 2026-10-01 from the
// official NC State Undergraduate Catalog (catalog.ncsu.edu/undergraduate/),
// whose Majors tab lists every program with its degree and links each one
// under the college that houses it; each group cites that college's catalog
// page. Concentrations are folded into their major (the catalog lists each
// concentration as its own line), and the online Agricultural Science line
// into the campus one. Left out: the Agricultural Institute's two-year AAS
// programs, the first-year programs (Engineering First Year, Life Sciences
// First Year, Environmental First Year, Exploratory Studies) and
// Inter-College Transfer, which are not bachelor's majors. Quirks: the
// catalog lists the Biological Engineering BS also as "Biological,
// Agricultural, and Ecological Engineering (BS)" (same page), kept once; it
// spells Parks, Recreation and Tourism Management two ways, kept once; the
// Natural Resources BS has concentrations in three colleges, kept under
// Natural Resources. Design and Social Work degrees are listed as
// "(Bachelor)"; the abbreviation or name is the program page's own (B.Arch,
// BEDA, BGXD, BSW, Bachelor of Industrial Design, Bachelor of Media Arts,
// Design and Technology). The KB's majors list was the starting point; the
// catalog wins.
const majors = {
    "slug": "north-carolina-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in NC State's official Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Concentrations, minors, certificates, two-year Agricultural Institute programs and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture and Life Sciences",
            "source": {
                "label": "NC State Undergraduate Catalog, College of Agriculture and Life Sciences",
                "url": "https://catalog.ncsu.edu/undergraduate/agriculture-life-sciences/"
            },
            "majors": [
                {
                    "name": "Agricultural Business Management",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Education",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Science",
                    "degree": "BS"
                },
                {
                    "name": "Agroecology & Sustainable Food Systems",
                    "degree": "BS"
                },
                {
                    "name": "Animal Science",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological and Agricultural Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Biological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Bioprocessing Science",
                    "degree": "BS"
                },
                {
                    "name": "Crop and Soil Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Food Science",
                    "degree": "BS"
                },
                {
                    "name": "Horticultural Science",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Plant Biology",
                    "degree": "BS"
                },
                {
                    "name": "Poultry Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Design",
            "source": {
                "label": "NC State Undergraduate Catalog, College of Design",
                "url": "https://catalog.ncsu.edu/undergraduate/design/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch",
                    "note": "One-year professional degree, after the Environmental Design in Architecture degree."
                },
                {
                    "name": "Design Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Design in Architecture",
                    "degree": "BEDA"
                },
                {
                    "name": "Graphic & Experience Design",
                    "degree": "BGXD"
                },
                {
                    "name": "Industrial Design",
                    "degree": "Bachelor of Industrial Design"
                },
                {
                    "name": "Media Arts, Design and Technology",
                    "degree": "Bachelor of Media Arts, Design and Technology"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "NC State Undergraduate Catalog, College of Education",
                "url": "https://catalog.ncsu.edu/undergraduate/education/"
            },
            "majors": [
                {
                    "name": "Applied Education Studies",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics Education",
                    "degree": "BS"
                },
                {
                    "name": "Middle Grades Education",
                    "degree": "BS"
                },
                {
                    "name": "Science Education",
                    "degree": "BS"
                },
                {
                    "name": "Technology, Engineering and Design Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "NC State Undergraduate Catalog, College of Engineering",
                "url": "https://catalog.ncsu.edu/undergraduate/engineering/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Humanities and Social Sciences",
            "source": {
                "label": "NC State Undergraduate Catalog, College of Humanities and Social Sciences",
                "url": "https://catalog.ncsu.edu/undergraduate/humanities-social-sciences/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Arts Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Criminology",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Leadership in the Public Sector",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Science, Technology and Society",
                    "degree": "BA"
                },
                {
                    "name": "Science, Technology and Society",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Poole College of Management",
            "source": {
                "label": "NC State Undergraduate Catalog, Poole College of Management",
                "url": "https://catalog.ncsu.edu/undergraduate/management/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Natural Resources",
            "source": {
                "label": "NC State Undergraduate Catalog, College of Natural Resources",
                "url": "https://catalog.ncsu.edu/undergraduate/natural-resources/"
            },
            "majors": [
                {
                    "name": "Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Technology and Management",
                    "degree": "BS"
                },
                {
                    "name": "Fisheries, Wildlife, and Conservation Biology",
                    "degree": "BS"
                },
                {
                    "name": "Forest Management",
                    "degree": "BS"
                },
                {
                    "name": "Natural Resources",
                    "degree": "BS",
                    "note": "Some concentrations are housed in the College of Agriculture and Life Sciences and the College of Sciences."
                },
                {
                    "name": "Paper Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Parks, Recreation and Tourism Management",
                    "degree": "BS"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Materials and Technology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Sciences",
            "source": {
                "label": "NC State Undergraduate Catalog, College of Sciences",
                "url": "https://catalog.ncsu.edu/undergraduate/sciences/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Genetics",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Marine Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Meteorology",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Zoology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Wilson College of Textiles",
            "source": {
                "label": "NC State Undergraduate Catalog, Wilson College of Textiles",
                "url": "https://catalog.ncsu.edu/undergraduate/textiles/"
            },
            "majors": [
                {
                    "name": "Fashion and Textile Design",
                    "degree": "BS"
                },
                {
                    "name": "Fashion and Textile Management",
                    "degree": "BS"
                },
                {
                    "name": "Polymer and Color Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Textile Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Textile Technology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "University College",
            "source": {
                "label": "NC State Undergraduate Catalog, University College",
                "url": "https://catalog.ncsu.edu/undergraduate/university-college/"
            },
            "majors": [
                {
                    "name": "Music Technology",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
